import { render, staticRenderFns } from "./select-familyStatus.vue?vue&type=template&id=5f28f920&"
import script from "./select-familyStatus.vue?vue&type=script&lang=js&"
export * from "./select-familyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports